import l10n from "@/services/l10n";

export default [
  {
    name: "rightholder",
    path: "/pages/rightholder",
    meta: { title: l10n("RIGHTHOLDER") },
    component: () =>
      import(/* webpackChunkName: "pages" */ "@/pages/Pages/Page.vue")
  },
  {
    name: "agreement",
    path: "/pages/agreement",
    meta: { title: l10n("AGREEMENT") },
    component: () =>
      import(/* webpackChunkName: "pages" */ "@/pages/Pages/Page.vue")
  },
  {
    name: "artistAgreement",
    path: "/pages/artist-agreement",
    meta: { title: l10n("AGREEMENT") },
    component: () =>
      import(/* webpackChunkName: "pages" */ "@/pages/Pages/Page.vue")
  },
  {
    name: "help",
    path: "/pages/help",
    meta: { title: l10n("HELP") },
    component: () =>
      import(/* webpackChunkName: "pages" */ "@/pages/Pages/Page.vue")
  }
];
